import React, { useEffect, useState } from "react";
import "./voditelj.css";

const Voditelj = () => {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    fetch("https://ghost-crew.eu/wp-json/wp/v2/posts/40?_embed")
      .then((res) => res.json())
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (loading) return <div className="vod-loader">Loading...</div>;
  if (!post) return <div className="vod-error">No post found</div>;

  const image =
    post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

  const author =
    post?._embedded?.author?.[0]?.name;

  const date = new Date(post.date).toLocaleDateString("hr-HR");

  return (
    <div className="vod-wrapper">

      {image && (
        <div
          className="vod-hero-img"
          style={{
            transform: `scale(${1 + scrollY * 0.0005})`,
            filter: `blur(${scrollY * 0.02}px)`,
          }}
        >
          <img src={image} alt="hero" />
          <div className="overlay" />
        </div>
      )}

      <div className="vod-hero">
        <h1>{post.title.rendered}</h1>

        {/* META INFO */}
        <div className="vod-meta">
          {author && <span>✍ {author}</span>}
          <span>📅 {date}</span>
        </div>
      </div>

      <div
        className="vod-content"
        dangerouslySetInnerHTML={{ __html: post.content.rendered }}
      />

    </div>
  );
};

export default Voditelj;